webpackJsonp([42],{

/***/ 1083:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_reportsummarybypart_js__ = __webpack_require__(1317);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f549fbc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reportsummarybypart_vue__ = __webpack_require__(1521);
var normalizeComponent = __webpack_require__(509)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_reportsummarybypart_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f549fbc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reportsummarybypart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1317:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_reportsummarybypart__ = __webpack_require__(1520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      date: '',
      search_text: '',
      data: [],
      is_load: false,
      result_data: [],
      count: 0,
      str_data: '',
      export_url: '',
      dk_id: '0',
      dockList: []
    };
  },
  created: function created() {
    this.checkOAuth();
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.getDockList();
      _this.date = __WEBPACK_IMPORTED_MODULE_2_moment___default()();
      $('#select2-dock').select2({
        placeholder: '- Select Dock -',
        allowClear: true,
        dropdownPosition: 'below'
      });
      $('#select2-dock').on('select2:select', function (e) {
        _this.changeDock($('#select2-dock').val());
      });
      $('#select2-dock').on('select2:clear', function (e) {
        _this.changeDock('0');
      });
    }, 1000);
  },

  methods: {
    getDockList: function getDockList() {
      var _this2 = this;

      this.dockList = [];
      __WEBPACK_IMPORTED_MODULE_1__models_reportsummarybypart__["a" /* default */].getDockList(this.$store.state.URLHost, this.header, function (result) {
        if (result.response === true) {
          _this2.dockList = result.data.dock_list;
        } else {
          // this.alert_msg('warning', 'An error occurred.', result.message)
        }
      }, function (error) {
        _this2.alert_msg('error', 'An error occurred.', error.message);
      });
    },
    changeDock: function changeDock(id) {
      this.dk_id = id;
      this.search();
    },
    exportData: function exportData(type) {
      var _this3 = this;

      // eslint-disable-next-line no-undef
      $('.preloader').fadeIn();
      var obj = {
        search: this.search_text,
        dk_id: this.dk_id,
        date: this.dateFormatDMY2(this.date)
      };
      this.header.params = obj;
      __WEBPACK_IMPORTED_MODULE_1__models_reportsummarybypart__["a" /* default */].ReportSummaryBYPart(this.$store.state.URLHost, this.header, function (result) {
        if (result.response === true) {
          _this3.str_data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(result.data);
          setTimeout(function () {
            if (type === 1) {
              _this3.$refs.ExportPDF.submit();
            } else {
              _this3.$refs.ExportExcel.submit();
            }
            // eslint-disable-next-line no-undef
            $('.preloader').fadeOut();
          }, 1000);
        } else {
          _this3.alert_msg('warning', 'Report Summary by Part', result.message);
          // eslint-disable-next-line no-undef
          $('.preloader').fadeOut();
        }
        _this3.isLoad = false;
      }, function (error) {
        // eslint-disable-next-line no-undef
        $('.preloader').fadeOut();
        _this3.alert_msg('error', 'Report Summary by Part', error.message);
        _this3.isLoad = false;
      });
    },
    search: function search() {
      var _this4 = this;

      this.is_load = true;
      var obj = {
        search: this.search_text,
        dk_id: this.dk_id,
        date: this.dateFormatDMY2(this.date)
      };
      this.result_data = [];
      this.header.params = obj;
      __WEBPACK_IMPORTED_MODULE_1__models_reportsummarybypart__["a" /* default */].ReportSummaryBYPart(this.$store.state.URLHost, this.header, function (result) {
        if (result.response === true) {
          _this4.result_data = result.data;
          _this4.count = result.count;
        } else {
          _this4.alert_msg('warning', 'Report Summary by Part', result.message);
        }
        _this4.is_load = false;
      }, function (error) {
        _this4.alert_msg('error', 'Report Summary by Part', error.message);
        _this4.is_load = false;
      });
    }
  }
});

/***/ }),

/***/ 1520:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(511);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  ReportSummaryBYPart: function ReportSummaryBYPart(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'report/summarybypart', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getDockList: function getDockList(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'report/docklist', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  }
});

/***/ }),

/***/ 1521:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body",staticStyle:{"position":"relative"}},[_c('div',{staticClass:"d-lg-flex"},[_c('div',[_c('h3',{staticClass:"card-title"},[_c('span',{staticClass:"lstick d-inline-block align-middle"}),_vm._v(_vm._s(_vm.$route.meta.title_sub ? _vm.$route.meta.title_sub : _vm.$route.meta.title))]),_vm._v(" "),_c('h6',{staticClass:"card-subtitle"})])]),_vm._v(" "),_c('div',{staticClass:"contianer"},[_c('div',{staticClass:"row mt-3 mb-2"},[_c('div',{staticClass:"col-md-2 col-sm-2 col-xs-12 p-r-0 mb-2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.dk_id),expression:"dk_id"}],staticClass:"form-select form-select-sm",staticStyle:{"width":"100%"},attrs:{"name":"active","id":"select2-dock"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.dk_id=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.search()}]}},[_c('option',{attrs:{"value":"0"}},[_vm._v("- Select Dock -")]),_vm._v(" "),_vm._l((_vm.dockList),function(dock,index){return _c('option',{key:'dk_' + index,domProps:{"value":dock.id}},[_vm._v(_vm._s(dock.code + ' (' + dock.name + ')'))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-sm-2 col-xs-12 p-r-0 mb-2"},[_c('a-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":'DD/MM/YYYY',"placeholder":"Select date"},on:{"change":function($event){return _vm.search()}},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-sm-3 col-xs-12 p-r-0 mb-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search_text),expression:"search_text"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","placeholder":"Please Enter keyword"},domProps:{"value":(_vm.search_text)},on:{"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.search()},function($event){_vm.search_text === '' ? _vm.search() : ''}],"input":function($event){if($event.target.composing){ return; }_vm.search_text=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-sm-1 col-xs-12 p-r-0 mb-2 d-grid gap-2"},[_c('button',{staticClass:"btn btn-secondary btn-sm btn-sm-fix",attrs:{"type":"button"},on:{"click":function($event){return _vm.search()}}},[_c('i',{staticClass:"fas fa-search mr-1"}),_vm._v(" Search")])]),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-sm-1 col-xs-12 p-r-0 mb-2"}),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-sm-2 col-xs-12 mb-2 d-grid gap-2"},[_c('div',{staticClass:"btn-group",attrs:{"role":"group"}},[_c('button',{staticClass:"btn btn-warning btn-sm btn-sm-fix dropdown-toggle",attrs:{"id":"btn_print","type":"button","data-bs-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false","disabled":_vm.result_data.length < 1 || _vm.is_load === true}},[_c('i',{staticClass:"fas fa-print mr-1"}),_vm._v(" Print\n            ")]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"btn_print"}},[_c('a',{staticClass:"dropdown-item",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.exportData(1)}}},[_vm._v("PDF")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.exportData(2)}}},[_vm._v("Excel")])])])])]),_vm._v(" "),_c('form',{ref:"ExportPDF",attrs:{"action":_vm.$store.state.URLBase + '/static/pdf/reportsummarybypart.php',"method":"post","target":"_blank"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.str_data),expression:"str_data"}],attrs:{"type":"hidden","name":"data"},domProps:{"value":(_vm.str_data)},on:{"input":function($event){if($event.target.composing){ return; }_vm.str_data=$event.target.value}}})]),_vm._v(" "),_c('form',{ref:"ExportExcel",attrs:{"action":_vm.$store.state.URLBase + '/static/excel/reportsummarybypart.php',"method":"post","target":"_blank"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.str_data),expression:"str_data"}],attrs:{"type":"hidden","name":"data"},domProps:{"value":(_vm.str_data)},on:{"input":function($event){if($event.target.composing){ return; }_vm.str_data=$event.target.value}}})]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"table-responsive tableFixHead"},[_c('table',{staticClass:"table customize-table mb-0 v-middle"},[_vm._m(0),_vm._v(" "),_c('tbody',[_c('tr',[(_vm.is_load === true)?_c('td',{staticClass:"text-center",attrs:{"colspan":"9"}},[_c('i',{staticClass:"fas fa-sync-alt fa-spin fa-2x fa-fw"})]):_vm._e()]),_vm._v(" "),_vm._l((_vm.result_data),function(row,key){return _c('tr',{key:'rbp_' + key},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(key + 1))]),_vm._v(" "),_c('td',{staticClass:"text-start"},[_vm._v(_vm._s(row.dk_code))]),_vm._v(" "),_c('td',{staticClass:"text-start"},[_vm._v(_vm._s(row.pr_id_number))]),_vm._v(" "),_c('td',{staticClass:"text-start"},[_vm._v(_vm._s(row.pr_number))]),_vm._v(" "),_c('td',{staticClass:"text-end"},[_vm._v(_vm._s(row.ps_qty_pack))]),_vm._v(" "),_c('td',{staticClass:"text-end"},[_vm._v(_vm._s(_vm.numberFormat(row.ps_qty_balance)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(row.ut_name))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(row.ispd_update != '' ? _vm.dateFormatDMY(row.ispd_update) : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(row.ispd_update != '' ? _vm.dateFormatTime(row.ispd_update) : '-'))])])}),_vm._v(" "),(_vm.count == 0 && _vm.is_load == false)?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"9"}},[_vm._v("No Data")])]):_vm._e()],2)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"table-light"},[_c('tr',[_c('th',{staticClass:"border-bottom border-top text-center"},[_vm._v("#")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-start"},[_vm._v("Dock Code")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-start"},[_vm._v("Part ID")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-start"},[_vm._v("Part Number")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-end"},[_vm._v("Qty/Box")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-end"},[_vm._v("Total Qty")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-center"},[_vm._v("Unit")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-center"},[_vm._v("Date")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-center"},[_vm._v("Time")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/42.bcfc098d6a088c846442.js